import { get, put } from '@/api/utils/http-utils.js'
import { checkResponse } from '@/api/utils/http-helpers.js'

/**
 * API functions for settings domain.
 */

export function getSettings () {
  return get('/settings').then(checkResponse)
}

export function updateSettings (payload) {
  return put('/settings', payload).then(checkResponse)
}
